module.exports = __webpack_public_path__ + "img/4.b36bb88.webp";